module.exports = __webpack_public_path__ + "static/light-wallpaper-thumb-7201f4bb768a40a2e0ea6bc2e1e238a7.jpg";